module.exports = __webpack_public_path__ + "img/google-play-logo.06a144fa.jpeg";